module.exports = __webpack_public_path__ + "static/media/AP-CHAP03-PHOTO.3b60cf81.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/StaticElement/img/AP-CHAP03-PHOTO.png
// module id = 303
// module chunks = 0